


import Swiper from 'vux/src/components/swiper/swiper.vue'
import SwiperItem from 'vux/src/components/swiper/swiper-item.vue'

export default {

components: { Swiper, SwiperItem },
data() {

return {
id: this.$route.query.id,
hotspot: null,
imgList: [],
myAudioSrc: null,
playing: false
};
},

computed: {},

watch: {},

methods: {
getDetail() {
let that = this;
that.get({
url: that.GLOBAL.BASE_URL + "/api/v1/map_view!getHotspotInfo.action",
params: { id: that.id },
isShowLoading: true,
success: function(data) {
console.log(data);
that.hotspot = data.data.hotspot;
that.imgList = data.data.imgList;
document.title = data.data.hotspot.name;

if (data.data.hotspot.audio != null) {
that.myAudioSrc =that.GLOBAL.DOMAIN_URL+data.data.hotspot.audio.split('.')[0]+'.mp3'
}

that.$nextTick(function() {
if (that.myAudioSrc != null) {
document.getElementById("scenicAudio").load();
}
});
}
});
},

playScenicAudio() {
let that = this;
let audio = document.getElementById("scenicAudio");
if (this.myAudioSrc == null) {
this.$vux.toast.text("暂无音频", "bottom");
} else {
if (audio.paused) {
audio.play();
audio.addEventListener("ended", function() {
that.playing = false;
});
this.playing = true;
} else {
audio.pause();
this.playing = false;
}
}
}
},

created() {},

mounted() {
this.getDetail();
},
beforeCreate() {}, //生命周期 - 创建之前
beforeMount() {}, //生命周期 - 挂载之前
beforeUpdate() {}, //生命周期 - 更新之前
updated() {}, //生命周期 - 更新之后
beforeDestroy() {}, //生命周期 - 销毁之前
destroyed() {}, //生命周期 - 销毁完成
activated() {} //如果页面有keep-alive缓存功能，这个函数会触发
};



// WEBPACK FOOTER //
// ./src/pages/ScenicDetail/ScenicDetail.vue